export enum BusinessModel {
  pumpxPro = 'pumpx_pro',
  pumpxPlus = 'pumpx_plus',
  pumpxBasic = 'pumpx_basic',
}

export namespace BusinessModel {
  export const translateType = (type: BusinessModel): string => {
    switch (type) {
      case BusinessModel.pumpxPro:
        return "PumpX Pro"
      case BusinessModel.pumpxPlus:
        return "PumpX Plus"
      case BusinessModel.pumpxBasic:
        return "PumpX Basic"
      default: return "";
    };
  };

  export const businessModelChoices: Array<{ id: string, name: string }> = Object.values(BusinessModel)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: BusinessModel.translateType(type as BusinessModel),
    } as { id: string, name: string }));
};